import React from "react";
import { Spin } from "antd";

// Centered spinner over a blurred backdrop. Uses a neutral, low-opacity tint
// (not a hardcoded white/black background) so it reads correctly whether the
// content behind it is light or dark. `fullScreen` covers the viewport (for a
// page that hasn't rendered anything yet); otherwise it covers the nearest
// `position: relative` ancestor, so the caller's own content stays visible
// (blurred) underneath instead of being unmounted while loading.
export default function Loader({ fullScreen = false, size = "large" }) {
  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        background: "rgba(128, 128, 128, 0.12)",
        zIndex: 10,
      }}
    >
      <Spin size={size} />
    </div>
  );
}
